import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Info } from '@bibliocommons/deprecated-base-icons';

export default function QuickStartLink({ policy, className, withIcons }) {
  return policy ? (
    <a
      href={policy.get('quickStartUrl')}
      target="_blank"
      rel="noopener noreferrer"
      className={cn('cp-quick-start-link', className)}
    >
      {withIcons && <Info />}
      <div>
        <FormattedMessage id="how_do_i_3m">{message => <span aria-hidden>{message}</span>}</FormattedMessage>
        <FormattedMessage id="ada_how_do_i_3m">
          {message => <ScreenReaderMessage>{message}</ScreenReaderMessage>}
        </FormattedMessage>
      </div>
    </a>
  ) : null;
}

QuickStartLink.propTypes = {
  policy: ImmutablePropTypes.map,
  className: PropTypes.string,
  withIcons: PropTypes.bool
};
